import { render, staticRenderFns } from "./TabCountBadge.vue?vue&type=template&id=700b5858"
import script from "./TabCountBadge.vue?vue&type=script&lang=js"
export * from "./TabCountBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports